
/**
 * 
 * @param {*} descriptor 
 * @returns {'yes'|'no'|'empty'}
 */
export function isFirstCardDynamic(descriptor) {
    if (descriptor) {
        const cards = descriptor.cards;

        if (!cards) {
            return 'empty';
        }

        if (!cards.length) {
            return 'empty';
        }

        const firstCard = cards[0];

        if (!firstCard) {
            return 'empty';
        }

        if (firstCard.url && firstCard.url.parametrized && firstCard.url.parametrized.indexOf('[dynamic]') !== -1) {
            return 'yes';
        } else {
            return 'no';
        }
    } else {
        return 'empty';
    }
}

/**
 * 
 * @param {*} descriptor 
 * @returns {}
 */
export function getFirstCardUrlTemplateInfo(descriptor) {
    if (descriptor) {
        const cards = descriptor.cards;

        if (!cards) {
            return null;
        }

        if (!cards.length) {
            return null;
        }

        const firstCard = cards[0];

        if (!firstCard) {
            return null;
        }

        if (firstCard.url && firstCard.url.parametrized) {
            return firstCard.url.parametrized;
        } else {
            return null;
        }
    } else {
        return null;
    }
}